import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup, DVFormControl, DVFormArray } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { FileHolder } from 'angular2-image-upload';

@Component({
  selector: 'app-add-article-item',
  templateUrl: './add-article-item.component.html',
  styleUrls: ['./add-article-item.component.css']
})
export class AddItemsComponent implements OnInit {

  @Input() articleForm: DVFormGroup;
  private articleItems: DVFormGroup;
  constructor() { }

  ngOnInit() {
    this.articleItems = this.articleForm.controls
      .items as DVFormGroup;
      
      this.articleItems = new DVFormGroup({
        body: new DVFormControl(),
        image: new DVFormControl(),
        position: new DVFormControl(),
        order: new DVFormControl(),
      });
  }
  imageUploaded(holder: FileHolder, index) {
    if (holder.serverResponse.status === 200) {
      const imageBody = holder.serverResponse.response.body;
      delete imageBody.message;
      this.addImage(imageBody, index);
    }
  }
  private addImage(src, index) {
    const control = <DVFormControl> this.articleItems.controls[`image`];
    const value: string = control.value || '';
    
    control.setValue(src.data.filePath);
    this.articleForm.controls
      .items.value[index].image = this.articleItems.value.image;
      console.log('eeeeeeeeeeeee' ,this.articleItems);
  }

  imageRemoved(holder: FileHolder) {
  }

}
